export default function Footer() {
  return(
    <footer>
      <p>Copyright © 2024 Andrew A. Cashner</p>
    </footer>
  );
}
